import React from "react";
import {useSelector} from "react-redux";
import {getImage} from "../../utils/utils";
import accountSVG from "../../images/account.svg";

const ThumbnailCurrentUser = () => {

    const {firstName, photo} = useSelector(state => state.currentUser)
    return (
        <div className={'user-thumbnail'}>
            <img src={getImage(photo, accountSVG)} className={'current-picture'} alt={"profil de l'utilisateur courant"}/>
            <p> {firstName} </p>
        </div>
    )
}

export default ThumbnailCurrentUser;